<template>
  <!--  TODO Replace with real content-->
  <div class="profile-mentions">
    <div class="profile-mentions__content">
      <h4 class="disabled">Нет информации</h4>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .profile-mentions {
    margin-top: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &__content {
      padding: 20px;
      background-color: #f2f4f8;
      border-radius: 4px;

      h4.disabled {
        color: $color-text-secondary-grey;
      }
    }
  }
</style>
